/** @format */

import React, { PureComponent }   from 'react';
import I18n                       from '../../../components/Translate/I18n';
import { Typography }             from '@material-ui/core';
import adescomStyle               from '../../../assets/jss/adescom/adescomStyle';
import withStyles                 from '@material-ui/core/styles/withStyles';
import compose                    from 'recompose/compose';
import CardHeader                 from '../../../components/Card/CardHeader';
import { GetBlockStateViewProps } from '../../../modules/block/BlockContainHelper';
import GridContainer              from '../../../components/Grid/GridContainer';
import GridItem                   from '../../../components/Grid/GridItem';
import { DateHelper }             from '../../../helpers/DateHelper';
import COLORS                     from "../../../assets/themes/OPL/colors";

class FinishCalledView extends PureComponent<GetBlockStateViewProps> {
    render(): React.ReactNode {
        const { stateBlock } = this.props;

        return (
            <CardHeader>
                <GridContainer>
                    <GridItem xs={11} style={{ backgroundColor: COLORS.DARK_FUNCTION.FUNCTION_3 }}>
                        <Typography variant="subtitle1">
                            <I18n trans="prov:f.state_id" />
                            {stateBlock.id + ' '}
                            <I18n trans="prov:f.get_ok" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={1} style={{ textAlign: 'right', backgroundColor: COLORS.ADDITIONAL.ADDITIONAL_5 }}>
                        <Typography variant="subtitle1">LOCAL</Typography>
                    </GridItem>
                    <GridItem xs={2}>
                        <I18n trans="prov:vb.block_start" />
                    </GridItem>
                    <GridItem xs={2}>{DateHelper.format(stateBlock.createdAt)}</GridItem>
                    <GridItem xs={2}>
                        <I18n trans="prov:vb.block_end" />
                    </GridItem>
                    <GridItem xs={6}>{DateHelper.format(stateBlock.lastRequestProcessed)}</GridItem>

                    <GridItem xs={2}>
                        <I18n trans="prov:vb.count_request" />
                    </GridItem>
                    <GridItem xs={2}>{stateBlock.requestCounter}</GridItem>
                    <GridItem xs={2}>
                        <I18n trans="prov:vb.max_count_request" />
                    </GridItem>
                    <GridItem xs={6}>{stateBlock.requestLimit}</GridItem>

                    <GridItem xs={2}>
                        <I18n trans="prov:vb.sleep_time_before_execute" />
                    </GridItem>
                    <GridItem xs={10}>{stateBlock.sleepSeconds}s</GridItem>
                </GridContainer>
            </CardHeader>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(FinishCalledView);
